$(document).ready(function () {
    // Check if there is a hero present
    var $hero = $('.hero');
    if ($hero.length > 0) {
        // Check if the video should be used
        if($hero.data("video-src")){
            // Check if the viewport is bigger than 900
            var viewportWidth = $(window).width();
            if(viewportWidth > 900 || $hero.data("video-on-mobile")){
                var videoSrc = $hero.data("video-src");
                var video = "<div class='hero-video-wrapper'>" +
                "<video muted class='hero-video' autoplay='true' loop='true' preload='auto' playsinline>"+
                "<source src='" + videoSrc + "'>" +
                "<img src=''></video></div>";
                $hero.prepend(video);
            }
        }
    };
});
